<template>
  <h4 class="mb-1">{{chapter}}</h4>
</template>

<script>
export default {
  name: 'ChapterIndex',

  props: {
    value: {
      type: String,
      required: true
    }
  },

  computed: {
    chapter () {
      return this.$gettext('Chapter') + ' ' + this.value
    }
  }
}
</script>

<style scoped lang="scss">

h4 {
  font-family: 'Lora', sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: $c-light-grey;
  padding-left: 30px;
  position: relative;

  @include breakpoint('md-and-up') {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    text-transform: none;
  }

  &::before {
    display: table;
    content: '';
    width: 20px;

    position: absolute;

    left: 0;

    position: absolute;
    border-bottom: 1px solid $c-light-grey;

    top: 50%;
    transform: translateY(-50%);

    margin: auto;
  }
}
</style>
